import React from "react";

const ProgramOverview = ({ overview }) => {
  return (
    <div className="md:scroll-mt-44 scroll-mt-16" id="overview">
      <div className=" ">
        <div className="max-w-6xl mx-auto py-5 md:py-16 px-2 md:px-10 ##md:px-10 space-y-3">
          <div>
            <h1 className="text-white font-bold text-lg">Program Overview</h1>
          </div>
          <div className="w-10 h-1 bg-sdorange"></div>
          <div className="text-gray-300 text-sm md:text-base text-justify whitespace-pre-line">
            {overview}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProgramOverview;
